exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@page {\r\n  size: 8.5in 11in;\n}\n@media print {\n.md-display-2[data-v-514a9d4a] {\r\n  page-break-before: always;\n}\n.no-print-but-display[data-v-514a9d4a]{\r\n  display: none;\n}\nh1[data-v-514a9d4a], h2[data-v-514a9d4a], h3[data-v-514a9d4a], h4[data-v-514a9d4a], h5[data-v-514a9d4a] {\r\n  page-break-after: avoid;\n}\n}\n.container[data-v-514a9d4a]{\r\n    max-width: 8.0in;\n}\n.md-card[data-v-514a9d4a] {\r\n    max-width: 600px;\r\n    margin: 4px;\r\n    display: block;\r\n    vertical-align: top;\n}\r\n", ""]);

// exports
